import { render } from "./event-intro.vue?vue&type=template&id=79605768&lang=pug"
import script from "./event-intro.vue?vue&type=script&lang=js"
export * from "./event-intro.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__